import {
  Component,
  HostBinding,
  Input,
  SimpleChange,
  SimpleChanges
} from '@angular/core';
import { IStep } from './models/step.interface';
import { DatePipe } from '@angular/common';
import { ClaimEditComponent } from 'src/app/pages/claims/components/edit/claim-edit.component';

@Component({
  selector: 'upsc-stepper4',
  templateUrl: './stepper4.component.html',
  styleUrls: ['./stepper4.component.scss']
})
export class Stepper4Component {
  @HostBinding('class') public hostClass = 'stepper';

  @Input() public steps: IStep[];
  @Input() public currentStep: number;

  public progress: number;

  public ngOnChanges(changes: SimpleChanges) {
    this.onCurrentStepChanged(changes['currentStep']);
  }

  constructor(private claimComp: ClaimEditComponent) {
  }

  private onCurrentStepChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      return;
    }

    this.setProgress();
  }


  public setCurrentStepManual(order: number) {
    this.claimComp.setCurrentStepManually(order);
  }

  private setProgress() {
    if (!this.steps || !this.steps.length) {
      this.progress = 0;
      return;
    }

    this.steps.forEach(
      (step) => {
        step.isActive = step.order === this.currentStep;
      },
    );

    this.progress = (this.currentStep - 1) * 100 / (this.steps.length - 1);
  }
}
